// src/utils/statusColors.js
export const statusColor = {
    Placed: 'active',
    Accepted: 'active',
    Preparing: 'active',
    Ready_For_Pickup: 'active',
    Picked_Up: 'active',
    Delivered: 'completed',
    Cancelled: 'cancelled',
    
    Pending: 'active',
    Paid: 'completed',
    Failed: 'cancelled',
  };
  